import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import "./InfoBreakdown.css";

const InfoBreakdown = () => {
  const { id } = useParams();
  const [record, setRecord] = useState(null);
  const navigate = useNavigate();

  // treat "NULL"/"null"/empty as null
  const normalizeVal = (v) => {
    if (v === undefined || v === null) return null;
    if (typeof v === "string") {
      const t = v.trim();
      if (t === "" || t.toLowerCase() === "null") return null;
      return t;
    }
    return v;
  };

  useEffect(() => {
    fetchBreakdownRecord();
  }, [id]);

  const fetchBreakdownRecord = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_API_URL}/breakdownRecords/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      // support: response.data can be array, object or { data: ... }
      let rec = response.data;
      if (Array.isArray(rec)) rec = rec[0] || {};
      if (rec && rec.data) rec = rec.data;

      const normalized = {};
      Object.keys(rec || {}).forEach((k) => {
        normalized[k.toLowerCase()] = normalizeVal(rec[k]);
      });

      setRecord(normalized);
    } catch (error) {
      console.error("Error fetching breakdown record:", error);
    }
  };

  const formatLocalDateTime = (dateString) => {
    if (!dateString) return "N/A";
    const localDate = new Date(dateString);
    if (isNaN(localDate.getTime())) return "N/A";
    const year = localDate.getFullYear();
    const month = String(localDate.getMonth() + 1).padStart(2, "0");
    const day = String(localDate.getDate()).padStart(2, "0");
    const hours = String(localDate.getHours()).padStart(2, "0");
    const minutes = String(localDate.getMinutes()).padStart(2, "0");
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };

  if (!record) return <div className="info-breakdown-loading">Loading...</div>;

  return (
    <div className="info-breakdown-container">
      <h1 className="info-breakdown-title">Breakdown Record Details</h1>
      <div className="info-breakdown-card">
        <div className="info-breakdown-row">
          <span className="info-breakdown-label">JP Number:</span>
          <span className="info-breakdown-value">
            {record.journey_plane_no || "N/A"}
          </span>
        </div>
        <div className="info-breakdown-row">
          <span className="info-breakdown-label">Truck Number:</span>
          <span className="info-breakdown-value">
            {record.scheduled_vehicle || "N/A"}
          </span>
        </div>
        <div className="info-breakdown-row">
          <span className="info-breakdown-label">Breakdown Date:</span>
          <span className="info-breakdown-value">
            {formatLocalDateTime(record.breakdown_time)}
          </span>
        </div>
        <div className="info-breakdown-row">
          <span className="info-breakdown-label">Driver Name:</span>
          <span className="info-breakdown-value">
            {record.driver_name || "N/A"}
          </span>
        </div>
        <div className="info-breakdown-row">
          <span className="info-breakdown-label">Driver Phone Number:</span>
          <span className="info-breakdown-value">
            {record.driver_phone || "N/A"}
          </span>
        </div>
        <div className="info-breakdown-row">
          <span className="info-breakdown-label">Last Check Point:</span>
          <span className="info-breakdown-value">
            {record.ivms_point || "N/A"}
          </span>
        </div>
        <div className="info-breakdown-row">
          <span className="info-breakdown-label">Carrier:</span>
          <span className="info-breakdown-value">
            {record.carrier || "N/A"}
          </span>
        </div>
        <div className="info-breakdown-row">
          <span className="info-breakdown-label">Issue:</span>
          <span className="info-breakdown-value">
            {record.issue || "N/A"}
          </span>
        </div>
        <div className="info-breakdown-row">
          <span className="info-breakdown-label">Truck Status:</span>
          <span className="info-breakdown-value">
            {record.truck_status || "N/A"}
          </span>
        </div>
        <div className="info-breakdown-row">
          <span className="info-breakdown-label">Breakdown Status:</span>
          <span className="info-breakdown-value">
            {record.breakdow_status || "N/A"}
          </span>
        </div>
        <div className="info-breakdown-row">
          <span className="info-breakdown-label">Date Resolved:</span>
          <span className="info-breakdown-value">
            {record.date_resolved ? formatLocalDateTime(record.date_resolved) : "N/A"}
          </span>
        </div>
      </div>
      <button
        className="info-breakdown-back-button"
        onClick={() => navigate("/breakdown-tracker")}
      >
        Back to List
      </button>
    </div>
  );
};

export default InfoBreakdown;
